<template>
  <h2 style="text-align: center;">All orders</h2>
  <div class="sync-btn" style="text-align: center;" title="Sync products with shopify">
        <icon-svg class="icon-menu" :height="25" :width="25" style="margin-inline: 8px; cursor: pointer"
          icon="material-symbols:cloud-sync-rounded" @click="syncOrdersFromShopifyToDB()" />
      </div>
      <span v-if="!finishSyncOrders">Syncing...</span>
  <div class="row mt-2">
    <div class="col-md-8">
      <table class="table responsive-table">
        <thead>
          <tr>
            <td>Order id</td>
            <td>Order number</td>
            <td>Total price</td>
            <td>Items</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(order, orderIndex) in orders" :key="orderIndex">
            <td>{{ order.orderId }}</td>
            <td>
              orderNumber={{ order.orderNumber }}
            </td>
            <!-- if (order.totalPrice !=  order.designPrice) - color is red and write order.totalPrice value and order.designPrice value and if is equal - color black and write the price -->
            <td :style="{ color: order.totalPrice != order.designPrice ? 'red' : 'black' }">
              <span v-if="order.totalPrice != order.designPrice">
                totalPrice={{ order.totalPrice }}$
                <br />
                designPrice={{ order.designPrice }}$
              </span>
              <span v-else>
                {{ order.totalPrice }}$
              </span>
            </td>
            <td>
              Items
              <icon-svg
                :icon="getTableIcon(order.orderId)"
                :height="25"
                :width="25"
                @click="openItems(order.orderId)"
              />
            <ul v-if="openOrderItems.find(f => f == order.orderId)">
              <li
                v-for="(item, itemIndex) in order.items"
                :key="itemIndex"
                style="text-align: -webkit-left"
              >
                <label class="fw-bold">Product sku: </label>{{ item.productSku }} <br />
                <label class="fw-bold">Quantity: </label>{{ item.quantity }} <br />
                <label class="fw-bold" style="display: flex;">
                  Images:
                  <span v-for="(image, index) in getImages(item)" :key="index">
                    <div :class="(dstDownloadFiles.find(f => f.orderNumber == order.orderNumber && f.imageName == image.imageName &&
                         f.lineIndex == itemIndex) != null &&
                        dstDownloadFiles.find(f => f.orderNumber == order.orderNumber &&
                         f.imageName == image.imageName && f.lineIndex == itemIndex).isDownloaded == true) ?
                        'bg-image hover-zoom downloadImg' : 'bg-image hover-zoom notDownloadImg'"
                          aria-controls="printDesignModal"
                          @click="(printDesignModal = true), printImage(item, image, order.orderNumber, itemIndex)"
                          :title="image.imageName"
                          style="
                            height: 10vh;
                            position: relative;
                            width: 10vh;
                            margin: 2px;
                            display: flex;
                            justify-content: center;
                            align-items: center;">
                      <img
                        style="position: absolute; padding: 5px; max-width: 100%; max-height: 100%;"
                        :src="image.file.relativePath.replaceAll('\\', '\\\\')"
                        hover-overlay
                        hover-zoom
                        hover-shadow
                      />
                    </div>
                  </span>
                </label>
                <br />
                <br />
              </li>
            </ul>
            </td>

          </tr>
        </tbody>
      </table>
      <span v-if="finishLoadingOrders == true">Loading orders...</span>
      <div class="text-center" v-if="finishLoadingOrders == true">
        <MDBSpinner />
      </div>
    </div>
  </div>

  <MDBModal
    id="printDesignModal"
    tabindex="-1"
    labelledby="printDesignModalLabel"
    v-model="printDesignModal"
    centered
    scrollable
  >
    <!-- staticBackdrop -->
    <EmbroidMechine
      v-if="printImageOpen"
      :product="productToPrint"
      :variantID="variantId"
      :imageName="imageNameToPrint"
      :item="itemToPrint"
      :designFromStore="uStore.userDesigns[productToPrint.productID].designs[variantId]"
      :orderNumber="orderNumberToPrint"
      :imagesNames="imagesNames"
      :cartLineIndex="cartLineIndex"
      :dstDownloadFiles="dstDownloadFiles"
    ></EmbroidMechine>
    <!-- <MDBModalFooter>
      <MDBBtn color="secondary" @click="printDesignModal = false">Close</MDBBtn>
    </MDBModalFooter> -->
  </MDBModal>

  <!-- <ProductDesign v-if="openChangeDesignPopup == true" 
  :_productId="productToPrint.productID" :_variantId="variantId"
  :_designObj="uStore.userDesigns[productToPrint.productID].designs[variantId]"
  :_imgToPreview="imageNameToPrint"></ProductDesign> -->
</template>


<script>
import { designerStore } from "@/stores/designerStore";
import EmbroidMechine from "./EmbroidMechine.vue";
// import ProductDesign from "./ProductDesign.vue";
import { ref } from "vue";
import { userStore } from "@/stores/userStore";
import {
  MDBModal,
  // MDBModalFooter,
  // MDBBtn,
  MDBSpinner,
} from "mdb-vue-ui-kit";

export default {
  setup() {

    const store = designerStore();
    const printDesignModal = ref(false);
    const uStore = userStore();
    return {
      store,
      printDesignModal,
      uStore
    };
  },
  components: {
    EmbroidMechine,
    // ProductDesign,
    MDBModal,
    // MDBModalFooter,
    // MDBBtn,
    MDBSpinner,
  },
  data() {
    return {
      openOrderItems: [],
      cuurentOrderId: null,
      orders: null,
      dstDownloadFiles: null,
      printImageOpen: null,
      productToPrint: null,
      variantId: null,
      imageNameToPrint: null,
      itemToPrint: null,
      orderNumberToPrint: null,
      imagesNames: null,
      cartLineIndex: null,
      finishLoadingOrders: true,
      finishSyncOrders: true,
      // openChangeDesignPopup: false,
    };
  },
  async mounted() {
    var orderData = await this.store.getAllOrdersFromShopify();
    this.orders = orderData.orders;
    this.dstDownloadFiles = orderData.dstDownloads;
    this.cuurentOrderId = this.orders.length != 0 ? Object.values(this.orders)[0].orderId : null;
    this.icon = "material-symbols:keyboard-arrow-down-rounded";
    this.finishLoadingOrders = false;
  },
  methods: {
    async syncOrdersFromShopifyToDB () {
      this.finishSyncOrders = false;
      var orderData = await this.store.syncOrdersFromShopifyToDB();
      this.orders = orderData.orders;
      this.dstDownloadFiles = orderData.dstDownloads;
      this.cuurentOrderId = this.orders.length != 0 ? Object.values(this.orders)[0].orderId : null;
      this.finishSyncOrders = true;
    },
    getTableIcon(orderId) {
      return this.openOrderItems.find(i => i == orderId)
        ? "material-symbols:keyboard-arrow-up-rounded"
        : "material-symbols:keyboard-arrow-down-rounded";
    },
    async openItems(orderId) {
      this.openOrderItems = this.openOrderItems.includes(orderId) == true
       ? this.openOrderItems.filter(i => i != orderId)
        : [...this.openOrderItems, orderId];
      this.dstDownloadFiles = await this.store.getDstDownloadFiles();
    },
    getImages(item) {
      var imgList = {};
      if(item.embDesign != "") {
        var design = JSON.parse(item.embDesign);
        var variantId = design.variantID;
        var images = Object.values(design.imgVariants);
        images.forEach((img) => {
          imgList[img.imageName] = this.store.allProducts[item.productId].variants[variantId].images[img.imageName];
        });
      }
      return Object.values(imgList);
    },
    async printImage(item, image, orderNumber, index) {
      this.fixDesignToUserDesign(item);
      this.productToPrint = this.store.allProducts[item.productId];
      this.variantId = JSON.parse(item.embDesign).variantID;
      this.imageNameToPrint = image.imageName;
      this.itemToPrint = item;
      this.orderNumberToPrint = orderNumber;


      //get user arts dst from DB
      //var userArts = this.uStore.userDesigns[this.productToPrint.productID].designs[this.variantId].imgVariants[this.imageNameToPrint].userArts;
      // if(userArts != undefined && userArts.length > 0) {
      //   //this.uStore.userDesigns[this.productToPrint.productID].designs[this.variantId].imgVariants[this.imageNameToPrint].userArts = await this.store.getUserArtsDst(userArts);
      //   this.allUserArts.value = await this.store.getUserArtsDst(userArts);
      // } else {
      //    this.uStore.userDesigns[this.productToPrint.productID].designs[this.variantId].imgVariants[this.imageNameToPrint].userArts = [];
      //   // await this.store.getUserArtsDst(this.designsObj[this.imageToPreview].userArts);
      // }

      //שומר רשימה של כל שמות התמונות שהורדו מההזמנה הזו ומהשורה הזו בסל
      this.imagesNames = Object.values(this.dstDownloadFiles.filter(f => f.orderNumber == orderNumber && f.lineIndex==index &&
       f.isDownloaded == true)).map(a=>a.imageName);
      this.cartLineIndex = index;
      this.printImageOpen = true;
    },
    fixDesignToUserDesign(item) {
      var _variantId = JSON.parse(item.embDesign).variantID;
      if(this.uStore.userDesigns[item.productId] === undefined) {
        this.uStore.userDesigns[item.productId] = {
          designIndex: item.productId,
          designID: this.store.createGuid(),
          productID: item.productId,
          designs: {},
        };
        this.uStore.userDesigns[item.productId].designs[_variantId] =
        JSON.parse(item.embDesign);
      } else {
        this.uStore.userDesigns[item.productId].designs[_variantId] =
        JSON.parse(item.embDesign);
      }
    },
  },
};
</script>
 <style scoped>
.oultine-text {
  -webkit-text-stroke: 0.5px black;
  border: 1px black solid;
  width: 100px;
}
.emb-canvas {
  height: 10vh;
  background-size: contain;
  background-repeat: no-repeat;
}
.modal-dialog {
  max-width: 80vw !important;
  /* max-height: 90vh !important; */
}
</style>
<style>
.downloadImg {
  border: solid 2px #e9c475;
}
.notDownloadImg {
  border: solid 2px #6f974c;
}
</style>

